import * as React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import AddIcon from '@mui/icons-material/Add';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { primaryButtonBackground } from '../../../constants/Colors';
import {
  mypageHeader,
  mypageHeaderTitle,
  mypageWrapper
} from '../../../constants/Location';
import { screenType } from '../../../constants/enum';
import Sidebar from '../../uiParts/Sidebar';
import TableInTransaction from '../../uiParts/TableInTransaction';

const styles = {
  mypageHeader,
  mypageHeaderTitle,
  mypageWrapper
};

const AgentInTransaction: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.agent.mypageClient');
  });

  const navigate = useNavigate();
  return (
    <>
      <Typography component="div" sx={styles.mypageWrapper}>
        <Sidebar screenType={screenType.agent} />
        <Typography
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            position: 'static',
            width: '100%'
          }}
        >
          <Typography sx={styles.mypageHeader} component="div">
            <Typography sx={styles.mypageHeaderTitle}>
              {t('mypage.clientList')}
            </Typography>
            <Button
              variant="contained"
              sx={[
                primaryButtonBackground,
                {
                  '@media screen and (max-width:960px)': {
                    height: '30px'
                  }
                }
              ]}
              onClick={() => navigate('/agent/client/basic')}
            >
              <AddIcon sx={{ color: '#FFF' }} />
              {t('mypage.addClient')}
            </Button>
          </Typography>
          <TableInTransaction />
        </Typography>
      </Typography>
    </>
  );
};

export default AgentInTransaction;
